import personalizeService from '../utils/rbmc.personalizeService';

const cartTracking = {
    bindHandler() {
        $(document.body).on('click', '.btn-checkout', function (evt) {
            evt.preventDefault();
            personalizeService
                    .getPersonalizedData()
                    .then((data) => {
                                // TRACKING: Tracking cart step 1
                                if ('checkout' in RedBull.tracking) {
                                    dataLayer.push(RedBull.tracking.checkout.UA);
                                    dataLayer.push(RedBull.tracking.checkout.GA4);
                                    setTimeout(function () {
                                        window.location.href = evt.currentTarget.href;
                                    }, 250);
                                } else {
                                    window.location.href = evt.currentTarget.href;
                                }

                            }
                    );
        });
    },

    addToCart(gtmProductData, qty) {
        dataLayer.push({
            'event':     'EECaddToCart',
            'ecommerce': {
                'currencyCode': gtmProductData.currencyCode,
                'add':          {
                    'products': [cartTracking.buildProductGTMString(gtmProductData, qty)]
                }
            }
        });

        dataLayer.push({
            event:     'add_to_cart',
            ecommerce: {
                currency: gtmProductData.currencyCode,
                items:    [cartTracking.buildProductGTMStringGA4(gtmProductData, qty)]
            }
        });
    },

    removeFromCart(gtmProductData, qty) {
        dataLayer.push({
            'event':     'EECremoveFromCart',
            'ecommerce': {
                'currencyCode': gtmProductData.currencyCode,
                'remove':       {
                    'products': [cartTracking.buildProductGTMString(gtmProductData, qty)]
                }
            }
        });

        dataLayer.push({
            event:     'remove_from_cart',
            ecommerce: {
                currency: gtmProductData.currencyCode,
                items:    [cartTracking.buildProductGTMStringGA4(gtmProductData, qty)]
            }
        });
    },

    buildProductGTMString(gtmProductData, qty) {
        return {
            'name':     gtmProductData.name,
            'id':       gtmProductData.id,
            'price':    !!gtmProductData.price ? gtmProductData.price.toString() : '',
            'brand':    gtmProductData.brand,
            'category': `${gtmProductData.gtmGender}/${gtmProductData.category}`,
            'quantity': qty
        };
    },

    buildProductGTMStringGA4(gtmProductData, qty) {
        return {
            'item_name':     gtmProductData.name,
            'item_id':       gtmProductData.id,
            'price':         !!gtmProductData.price ? gtmProductData.price.toString() : '',
            'item_brand':    gtmProductData.brand,
            'item_category': `${gtmProductData.gtmGender}/${gtmProductData.category}`,
            'quantity':      qty
        };
    },
};

$(() => {
    if ($('#cart-page').length) {
        cartTracking.bindHandler();
    }
});

export default cartTracking;
